<template>
        <div>
        <div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <app-tabela
                idTabela="tblHistoricoUsuario"
                :itens="historico"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="vigencia" slot-scope="data">
                    {{
                        data.dtLog
                            ? $moment(data.dtLog).format(
                                  'DD/MM/YYYY  HH:mm:ss'
                              )
                            : ''
                    }}
                </template>
            </app-tabela>
        </div>
    </div>
</template>

<script>
import ContratosServicos from '../ContratosServicos'

export default {
    components: {},

    props: {
        contrato: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            erros: [],
            historico: [],
            campos: [
                {
                    key: 'data',
                    label: 'Data',
                    sortable: true,
                    type: 'datetime'
                },
                {
                    key: 'usuario',
                    label: 'Usuário',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'situacaoAnterior',
                    label: 'Situação Anterior',
                    filterable: true
                },
                {
                    key: 'situacaoPosterior',
                    label: 'Situação Posterior',
                    filterable: true
                },
                {
                    key: 'acao',
                    label: 'Ação',
                    filterable: true
                },
                {
                    key: 'observacao',
                    label: 'Observação',
                    filterable: true
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        obterHistoricoContrato(contrato) {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterHistoricoContratoAlteracoesUsuario(contrato).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.historico = response.data;
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },
    },

    created() {},

    computed: {},

    watch: {
        contrato(newValue, oldValue) {
            this.obterHistoricoContrato(newValue)
        }
    }
}
</script>